import React from 'react';
import ObservationGrid from './ObservationGrid';

export default function Observation() {
  return <ObservationGrid />;
}
